var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        var HotelCardsPhoto = function () {
            function HotelCardsPhoto() {
                var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.hotel-photo-swiper';
                var labels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, HotelCardsPhoto);

                this.labels = labels;
                this.galleries = [];
                this.addElements(document.querySelectorAll(selector));
            }

            _createClass(HotelCardsPhoto, [{
                key: "addElements",
                value: function addElements(elements) {
                    var _this = this;

                    Array.from(elements).forEach(function (element) {
                        element.classList.add('hotel-photo-native');
                        var state = { element: element, track: element.querySelector('.swiper-wrapper'), index: 0, allowClick: true, cleanups: [] };
                        _this.galleries.push(state);
                        element.hotelPhotoGallery = state;
                        var pagination = element.querySelector('.swiper-pagination');
                        pagination.className = 'hotel-photo-controls';
                        pagination.innerHTML = '';
                        state.previous = _this.button('hotel-photo-arrow hotel-photo-arrow--previous', '‹', _this.labels.previousPhoto || '‹');
                        state.next = _this.button('hotel-photo-arrow hotel-photo-arrow--next', '›', _this.labels.nextPhoto || '›');
                        pagination.appendChild(state.previous);
                        pagination.appendChild(state.next);
                        _this.listen(state, state.previous, 'click', function (event) {
                            event.stopPropagation();_this.goTo(state, state.index - 1);
                        });
                        _this.listen(state, state.next, 'click', function (event) {
                            event.stopPropagation();_this.goTo(state, state.index + 1);
                        });
                        _this.listen(state, state.track, 'scroll', function () {
                            if (state.frame != null) return;
                            state.frame = window.requestAnimationFrame(function () {
                                state.frame = null;
                                if (_this.destroyed) return;
                                _this.update(state);
                                if (state.index > 0) _this.loadRemaining(state);
                            });
                        }, { passive: true });
                        _this.bindDrag(state);
                        _this.update(state);
                    });
                }
            }, {
                key: "button",
                value: function button(className, text, label) {
                    var button = document.createElement('button');
                    button.type = 'button';
                    button.className = className;
                    button.textContent = text;
                    button.setAttribute('aria-label', label);
                    return button;
                }
            }, {
                key: "listen",
                value: function listen(state, target, name, callback, options) {
                    target.addEventListener(name, callback, options);
                    state.cleanups.push(function () {
                        return target.removeEventListener(name, callback, options);
                    });
                }
            }, {
                key: "bindDrag",
                value: function bindDrag(state) {
                    var _this2 = this;

                    var start = null;
                    this.listen(state, state.track, 'pointerdown', function (event) {
                        if (!event.isPrimary || event.button !== 0) return;
                        state.allowClick = true;
                        start = { x: event.pageX, y: event.pageY, left: state.track.scrollLeft, id: event.pointerId, mouse: event.pointerType === 'mouse' };
                    }, { passive: true });
                    this.listen(state, state.track, 'pointermove', function (event) {
                        if (!start || event.pointerId !== start.id) return;
                        var dx = event.pageX - start.x,
                            dy = event.pageY - start.y;
                        if (Math.abs(dx) < 10 || Math.abs(dx) <= Math.abs(dy)) return;
                        state.allowClick = false;
                        _this2.loadRemaining(state);
                        if (start.mouse) {
                            state.track.classList.add('is-dragging');
                            state.track.setPointerCapture(event.pointerId);
                            state.track.scrollLeft = start.left - dx;
                        }
                    }, { passive: true });
                    var end = function end() {
                        if (start && start.mouse && !state.allowClick) {
                            state.track.classList.remove('is-dragging');
                            _this2.goTo(state, Math.round(state.track.scrollLeft / state.track.clientWidth));
                        }
                        start = null;
                    };
                    this.listen(state, state.track, 'pointerup', end);
                    this.listen(state, state.track, 'pointercancel', end);
                    this.listen(state, state.track, 'click', function (event) {
                        if (!state.allowClick) {
                            event.preventDefault();event.stopPropagation();
                        }
                    }, true);
                }
            }, {
                key: "update",
                value: function update(state) {
                    state.index = Math.round(state.track.scrollLeft / state.track.clientWidth);
                    state.previous.disabled = state.index === 0;
                    state.next.disabled = state.index >= Math.max(state.track.children.length, Number(state.element.dataset.photosCount || 0)) - 1;
                    Array.from(state.track.children).forEach(function (slide, index) {
                        var img = slide.querySelector('img');
                        if (!img) return;
                        img.draggable = false;
                        if (Math.abs(index - state.index) <= 1 && !img.src) {
                            img.loading = 'lazy';
                            img.src = img.dataset.src;
                        }
                    });
                }
            }, {
                key: "goTo",
                value: function goTo(state, index) {
                    var _this3 = this;

                    var scroll = function scroll() {
                        if (_this3.destroyed) return;
                        var target = Math.max(0, Math.min(index, state.track.children.length - 1));
                        state.track.scrollTo({ left: target * state.track.clientWidth, behavior: 'smooth' });
                    };
                    var loading = this.loadRemaining(state);
                    if (index >= state.track.children.length) return loading.then(scroll);
                    scroll();
                    return Promise.resolve();
                }
            }, {
                key: "loadRemaining",
                value: function loadRemaining(state) {
                    var _this4 = this;

                    var element = state.element;
                    if (element.dataset.hasMorePhotos === '0') return Promise.resolve();
                    if (state.request) return state.request;
                    state.request = this.fetchSlides(element).then(function (photos) {
                        if (_this4.destroyed) return;
                        _this4.addSlides(state, photos);
                        element.dataset.hasMorePhotos = '0';
                    }).catch(function (error) {
                        state.request = null;console.error('Hotel gallery:', error);
                    });
                    return state.request;
                }
            }, {
                key: "fetchSlides",
                value: function fetchSlides(swiperInstance) {
                    var hotelId = swiperInstance.dataset.hotelId;
                    if (!HotelCardsPhoto.requests.has(hotelId)) {
                        var url = swiperInstance.dataset.photosUrl || "/new/hotel/hotel-photos?hotelId=" + encodeURIComponent(hotelId) + "&limit=20";
                        HotelCardsPhoto.requests.set(hotelId, fetch(url).then(function (response) {
                            if (!response.ok) throw new Error("HTTP " + response.status);
                            return response.json();
                        }).catch(function (error) {
                            HotelCardsPhoto.requests.delete(hotelId);
                            throw error;
                        }));
                    }
                    return HotelCardsPhoto.requests.get(hotelId);
                }
            }, {
                key: "addSlides",
                value: function addSlides(state, photos) {
                    var existing = new Set(Array.from(state.track.children, function (slide) {
                        return slide.querySelector('img').dataset.src;
                    }));
                    photos.forEach(function (src) {
                        if (existing.has(src) || existing.size >= 20) return;
                        var slide = document.createElement('div');
                        slide.className = 'swiper-slide';
                        var img = document.createElement('img');
                        img.dataset.src = src;
                        img.alt = '';
                        slide.appendChild(img);
                        state.track.appendChild(slide);
                        existing.add(src);
                    });
                    this.update(state);
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.destroyed = true;
                    this.galleries.forEach(function (state) {
                        state.cleanups.forEach(function (cleanup) {
                            return cleanup();
                        });
                        if (state.frame != null) window.cancelAnimationFrame(state.frame);
                        delete state.element.hotelPhotoGallery;
                    });
                }
            }]);

            return HotelCardsPhoto;
        }();

        HotelCardsPhoto.requests = new Map();
        window.HotelCardsPhoto = HotelCardsPhoto;
    }, {}] }, {}, [1]);